<div *ngIf="address" (click)="selectAddress()" class="address" [ngClass]="{ active: (active$ | async) === address.id }">
  <sd-dropdown #dropdown (click)="stopPropagation($event)" class="dropdown">
    <ng-template #dropdownToggler>
      <sd-dropdown-toggler (click)="dropdown.toggle()" [hideArrow]="true">
        <button class="btn btn-more btn-link">
          <cx-icon class="icon" [type]="iconType.ELLIPSIS"></cx-icon>
        </button>
      </sd-dropdown-toggler>
    </ng-template>

    <ng-template #dropdownContent>
      <sd-dropdown-menu>
        <sd-dropdown-menu-item (click)="dropdown.close(); editAddress($event)">Редактировать</sd-dropdown-menu-item>
        <sd-dropdown-menu-item (click)="dropdown.close(); deleteSavedAddress()">Удалить</sd-dropdown-menu-item>
      </sd-dropdown-menu>
    </ng-template>
  </sd-dropdown>

  <div class="address-block">{{ address.formattedAddress }} , {{ address.appartment }}</div>

  <div class="address-details">
    <span *ngIf="address.entrance">Подъезд: {{ address.entrance }}</span>
    <span *ngIf="address.floor">Этаж: {{ address.floor }}</span>
    <span *ngIf="address.domofon">Домофон: {{ address.domofon }}</span>
  </div>
</div>
